// ============================================================================
// ConfBar — flat horizontal confidence indicator.
//
// Used inside dense signal rows where a full ConfRing would dominate the
// row height. 5px tall, pill-rounded, colour-coded by the same thresholds
// as ConfRing.
// ============================================================================

export default function ConfBar({ value, w = 56 }) {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  const col = v >= 75 ? '#22c55e' : v >= 55 ? '#f59e0b' : '#ef4444';
  return (
    <div style={{
      width: w, height: 5,
      borderRadius: 'var(--r-pill)',
      background: 'var(--bg-elevated)',
      overflow: 'hidden',
    }} aria-label={`Confidence ${Math.round(v)}%`}>
      <div style={{
        width: v + '%', height: '100%',
        background: col,
        borderRadius: 'var(--r-pill)',
      }} />
    </div>
  );
}
